import { render, staticRenderFns } from "./MainReports.vue?vue&type=template&id=876a23b4&"
import script from "./MainReports.vue?vue&type=script&lang=js&"
export * from "./MainReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports